import React from 'react';

import { TextField } from '@material-ui/core';

export const EventHistoryTotals = () => {
  return (
    <div className="total-earnings-container">
      <div>
        <div className="stats-container">
          <div className="stats-values">
            <p>TOTAL POINTS</p>
            <TextField
              id="outlined-bare"
              className="stats-text-field"
              InputProps={{
                classes: {
                  input: 'stats-text-field__input override'
                }
              }}
              defaultValue={'-'}
              margin="normal"
              disabled={true}
              variant="outlined"
            />
          </div>

          <div className="stats-values">
            <p>TOTAL SCRIP EARNINGS</p>
            <TextField
              id="outlined-bare"
              className="stats-text-field"
              InputProps={{
                classes: {
                  input: 'stats-text-field__input override'
                }
              }}
              defaultValue={'-'}
              margin="normal"
              disabled={true}
              variant="outlined"
            />
          </div>

          <div className="stats-values">
            <p>TOTAL CASH EARNINGS</p>
            <TextField
              id="outlined-bare"
              className="stats-text-field"
              InputProps={{
                classes: {
                  input: 'stats-text-field__input override'
                }
              }}
              defaultValue={'-'}
              margin="normal"
              disabled={true}
              variant="outlined"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
